import { css as _css } from "@emotion/core";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import * as styles from './rotating-text.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var RotatingText = _ref => {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$dwell = _ref.dwell,
    dwell = _ref$dwell === void 0 ? 5000 : _ref$dwell,
    _ref$fadeDuration = _ref.fadeDuration,
    fadeDuration = _ref$fadeDuration === void 0 ? 500 : _ref$fadeDuration,
    _ref$crossover = _ref.crossover,
    crossover = _ref$crossover === void 0 ? 0.2 : _ref$crossover,
    _ref$seed = _ref.seed,
    seed = _ref$seed === void 0 ? 0 : _ref$seed;
  var isArray = Array.isArray(text);
  var items = isArray ? text : [text];
  var beforeStart = seed % items.length - 1;
  var rotationEnabled = dwell > 0;
  var _useState = useState(beforeStart),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var nextIndex = (index + 1) % items.length;
  var started = index !== beforeStart;
  var effectiveDwell = started ? dwell : dwell - fadeDuration;
  useEffect(() => {
    if (items.length > 1 && rotationEnabled) {
      var interval = setInterval(() => setIndex(nextIndex), effectiveDwell);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [nextIndex, setIndex, isArray, effectiveDwell, items.length, rotationEnabled]);
  var currentLine = items[index];
  var nextLine = items[nextIndex];
  if ((typeof currentLine === 'object' || currentLine == null) && typeof nextLine === 'object') {
    return ___EmotionJSX("span", {
      css: styles.container
    }, started && ___EmotionJSX("span", {
      key: index,
      css: /*#__PURE__*/_css([styles.child, styles.fadeOut({
        fadeDuration
      })])
    }, currentLine.line1, ___EmotionJSX("br", null), currentLine.line2), ___EmotionJSX("span", {
      key: "next-".concat(nextIndex),
      css: /*#__PURE__*/_css([styles.nextChild, started && styles.fadeIn({
        fadeDuration,
        crossover
      })])
    }, nextLine.line1, ___EmotionJSX("br", null), nextLine.line2));
  }
  var line = typeof currentLine === 'object' ? "".concat(currentLine.line1, " ").concat(currentLine.line2) : currentLine;
  var lineNext = typeof nextLine === 'object' ? "".concat(nextLine.line1, " ").concat(nextLine.line2) : nextLine;
  return ___EmotionJSX("span", {
    css: styles.container
  }, started && ___EmotionJSX("span", {
    key: index,
    css: /*#__PURE__*/_css([styles.child, styles.fadeOut({
      fadeDuration
    })])
  }, line), ___EmotionJSX("span", {
    key: "next-".concat(nextIndex),
    css: /*#__PURE__*/_css([styles.nextChild, started && styles.fadeIn({
      fadeDuration,
      crossover
    })])
  }, lineNext));
};